import {css} from 'lit';
export const styles = css`:host{display:inherit}.collapse-wrapper{transition:max-height .35s ease;font-family:"Open Sans","Helvetica Neue","Helvetica","Arial",sans-serif;width:100%}`;
export default styles;
